
export const toggleMap = id => ({ 
    type: "TOGGLE_MAP", 
    id 
})

export const updateMapView = (id) => ({
    type: "UPDATE_MAP_VIEW",
    id
})
